var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCriticalHigh = function SvgCriticalHigh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.338228 12.3984L6.89224 1.19886C7.8256 -0.399621 10.1744 -0.399621 11.118 1.19886L17.672 12.3984C18.6054 13.9968 17.4361 16 15.5591 16H2.44085C0.563878 16 -0.605381 13.9968 0.327977 12.3984H0.338228Z",
    fill: "#F3BA1A"
  })));
};
export default SvgCriticalHigh;